import { BaseEntity, type Searchable } from './base'
import type { PracticePhase, PracticeTypeRow } from './practice-type'

export class DeadlineType extends BaseEntity implements Searchable {
  displayName!: string
  icon!: string
  targetPhaseId!: string | null
  practiceTypeId!: string
  color!: string | null
  visible!: boolean
  category!: string | null

  get searchString() {
    return this.displayName + ' ' + (this.category || '')
  }
}

export class NewDeadlineType {
  displayName!: string
  icon!: string
  targetPhaseId?: string | null
  color?: string | null
  visible?: boolean
  category?: string | null
}

export class UpdateDeadlineType {
  displayName?: string
  icon?: string
  targetPhaseId?: string | null
  color?: string | null
  visible?: boolean
  category?: string | null
}

export interface DeadlineTypeWritten {
  deadlineType: DeadlineType
}

export class DeadlineTypeWithPhase extends DeadlineType {
  targetPhase!: PracticePhase | null
}

export class DeadlineTypeWithPracticeType extends DeadlineType {
  practiceType!: PracticeTypeRow
}

export interface GetDeadlineTypesMatching {
  deadlineTypes: DeadlineTypeWithPracticeType[]
}
